import {
  Phone,
  //  Clock
} from "lucide-react";
import moment from "moment";
import {
  getCallColor,
  userTimeZone,
  validCodes,
  validEvents,
} from "./constants";
import { OngoingBadge } from "./callAnswered/OngoingBadge";

const CallIconPulse = ({ colors }) => (
  <div className="relative">
    <span
      className={`absolute inset-0 rounded-full ${colors.main} opacity-60 animate-ping`}
    />
    <span
      className={`absolute inset-0 rounded-full ${colors.light} opacity-50 animate-pulse`}
    />

    <div
      className={`relative p-2 rounded-full ${colors.iconBg} flex items-center justify-center`}
    >
      <Phone className={`w-5 h-5 ${colors.iconColor}`} />
    </div>
  </div>
);

const CallStatusText = ({ callerInfo }) => {
  const type = callerInfo?.eventType;
  const code = callerInfo?.code;
  if (!validEvents.includes(type || "") || !validCodes.includes(code || "")) {
    return null;
  }
  const formatted =
    callerInfo?.timestamp && userTimeZone(callerInfo?.timestamp);
  // const time = callerInfo?.timestamp
  //   ? moment.utc(callerInfo?.timestamp).local().format("HH:mm:ss")
  //   : "—";
  if (type === "call_inbound" && code === "Setup")
    return (
      <div>
        <h3 className="text-lg font-semibold text-gray-900">Incoming Call</h3>
        <p className="text-sm text-gray-500">
          {formatted ? formatted.timeWithSeconds : "--"} |
          <span className="text-[#2C6DFF]"> Ringing...</span>
        </p>
      </div>
    );

  if (type === "call_outbound" && code === "Setup")
    return (
      <div>
        <h3 className="text-lg font-semibold text-gray-900">Outgoing Call</h3>
        <p className="text-sm text-gray-500">
          {formatted ? formatted.timeWithSeconds : "--"} |
          <span className="text-[#2C6DFF]"> Ringing...</span>
        </p>
      </div>
    );

  if (code === "Answered")
    return (
      <div>
        <h3 className="text-lg font-semibold text-gray-900">Connected</h3>
      </div>
    );

  if (code === "Disconnected")
    return (
      <div>
        <h3 className="text-lg font-semibold text-gray-900">
          Disconnected Call
        </h3>
        {/* <p className="text-sm text-gray-500">Call Disconnected by Customer</p> */}
      </div>
    );

  return null;
};

const CallerHeader = ({ callerInfo }) => {
  const colors = getCallColor(callerInfo);
  const type = callerInfo?.eventType;
  const code = callerInfo?.code;
  if (!validEvents.includes(type || "") || !validCodes.includes(code || "")) {
    return null;
  }
  return (
    <div className="flex items-center justify-between ">
      <div className="flex items-center space-x-3">
        <CallIconPulse colors={colors} />

        <CallStatusText callerInfo={callerInfo} />
      </div>

      {code === "Answered" && (
        <OngoingBadge
          callerInfo={callerInfo}
          className="flex items-center gap-x-1 bg-green-200 rounded-full px-4 py-2"
        />
      )}

      {/* <button
        className="focus:outline-none hover:bg-white/100 bg-white/5 transition-all hover:rotate-180 flex items-center justify-center border rounded-full w-9 h-9"
        onClick={onClose}
      >
        <Lucide className="w-7 h-7 stroke-[1]" icon="X" />
      </button> */}
    </div>
  );
};

export default CallerHeader;
